export default arr => arr && arr[Math.floor(Math.random() * arr.length)]
